module.exports = __webpack_public_path__ + "img/img12.55dc656b.png";